// extracted by mini-css-extract-plugin
module.exports = {"tag":"ProductCard_tag__5d7bm","brand":"ProductCard_brand__H8Anc","cardTitle":"ProductCard_cardTitle___X5Vy","featuredCardTitle":"ProductCard_featuredCardTitle__lmb9G"};